<template>
  <div>
    <the-header />
    <div class="animationFix">
      <slot />
    </div>
    <the-footer />
  </div>
</template>
<script>
import TheHeader from '../components/Common/TheHeader';
import TheFooter from '../components/Common/TheFooter';
export default {
  components: {
    TheHeader,
    TheFooter
  },
  created(){
    let broker_categorization = []
    let campaign_status = []
    let localities = []
    let campaign_types = []
    let statuses = []
    let enquirystatuses = []
    let projects = []
    let enquiry_sources = []
    let brokers = []
    let assigned_to = []
    let dead_reasons = []
    let field_executives = []
    let team_leads = []
    let performance = []
    let statuses_building_broker = []
    let brokers_firm_name = []
    let meeting_types = []
    let premium_enq_projects = []
    let premium_enq_statuses = []
    let brokers_uuids = []
    this.$axios.get('buildings/settings')
      .then(res => {
        res.data.localities.forEach((item,index) => {
          localities.push({value: item.id, text: item.name})
        });
        localities.unshift({value: null, text: 'Select One'})

        res.data.campaign_types.forEach((item,index) => {
          campaign_types.push({value: item, text: item})
        });
        campaign_types.unshift({value: null, text: 'Select Type'})

        res.data.statuses.forEach((item,index) => {
          statuses.push({value: item.id, text: item.name})
        });
        statuses.unshift({value: null, text: 'Select One'})

        res.data.performance.forEach((item,index) => {
          performance.push({value: item, text: item})
        });
        performance.unshift({value: null, text: 'Select Performance'})

        res.data.statuses_building_broker.forEach((item,index) => {
          statuses_building_broker.push({value: item.id, text: item.name})
        });
        statuses_building_broker.unshift({value: null, text: 'Select Status'})

        this.$store.dispatch('setLocalitiesMaster', localities)
        this.$store.dispatch('setCampaignTypesMaster', campaign_types)
        this.$store.dispatch('setStatusesMaster', statuses)
        this.$store.dispatch('setPerformance', performance)
        this.$store.dispatch('setBuildingBrokerStatus', statuses_building_broker)
      })
      .catch(err => console.log(err.response))

    this.$axios.get('/enquiries_builders/settings')
      .then(res => {
        // console.log(res.data)
        res.data.statuses.forEach((item,index) => {
          enquirystatuses.push({value: item.id, text: item.name})
        });
        enquirystatuses.unshift({value: null, text: 'Status'})

        res.data.projects.forEach((item,index) => {
          projects.push({value: item.id, text: item.name})
        });
        projects.unshift({value: null, text: 'Select Project'})

        res.data.enquiry_sources.forEach((item,index) => {
          enquiry_sources.push({value: item.id, text: item.name})
        });
        enquiry_sources.unshift({value: null, text: 'Lead Source'})

        res.data.brokers.forEach((item,index) => {
          brokers.push({value: item.id, text: item.firm_name})
        });
        brokers.unshift({value: null, text: 'Select Broker'})

        res.data.assigned_to.forEach((item,index) => {
          assigned_to.push({value: item.id, text: item.full_name})
        });
        assigned_to.unshift({value: null, text: 'Assigned To'})

        res.data.dead_reasons.forEach((item,index) => {
          dead_reasons.push({value: item.reason, text: item.reason, question: item.question, seq: item.seq })
        });
        dead_reasons.unshift({value: null, text: 'Dead Reasons'})
        this.$store.state.can_create = res?.data?.can_create;
        this.$store.dispatch('setEnquiryStatusesMaster', enquirystatuses)
        this.$store.dispatch('setProjectsMaster', projects)
        this.$store.dispatch('setEnquirySourcesMaster', enquiry_sources)
        this.$store.dispatch('setbrokersMaster', brokers)
        this.$store.dispatch('setAssignedToMaster', assigned_to)
        this.$store.dispatch('setDeadReasonToMaster', dead_reasons)
      })
    .catch(err => console.log(err.response))

    this.$axios.get('users/meetings/settings')
      .then(res => {
        this.$store.dispatch('setIsManager', res.data.is_manager);
        if(res.data.field_executives){
          res.data.field_executives.forEach((item,index) => {
            field_executives.push({value: item.id, text: item.full_name})
          });
        }
        field_executives.unshift({value: null, text: 'Select Executive'})

        this.$store.dispatch('setFieldExecutiveMaster', field_executives);
        if(res.data.team_leads){
          res.data.team_leads.forEach((item, index) => {
            team_leads.push({value: item.id, text: item.full_name})
          });
        }
        team_leads.unshift({value: null, text: 'Select Team Lead'})
        this.$store.dispatch('setTeamLeadMaster',team_leads)

        if(res.data.brokers){
          res.data.brokers.forEach((item, index) =>{
            brokers_firm_name.push({value: item.id, text: item.name_with_firm_name, lat: item.lat, long: item.long})
          });
        }
        brokers_firm_name.unshift({value: null, text: "Broker - Firm Name", lat: null, long: null});
        this.$store.dispatch('setBrokersFirmNameMaster',brokers_firm_name);
        if(res.data.meeting_types){
          meeting_types = res.data.meeting_types.map(meeting_type => ({
            value: meeting_type,
            text: meeting_type
          }));
        }
        meeting_types.unshift({value:null, text: 'Select Meeting Type'});
        this.$store.dispatch('setMeetingTypesMaster',meeting_types);

        if(res.data.broker_categorizations){
          console.log(res.data.broker_categorizations,"broker_categorizations")
          broker_categorization = Object.keys(res.data.broker_categorizations).map(category => ({
              text: category,
              value: res.data.broker_categorizations[category]
          }));
          broker_categorization.unshift({
              text: 'Select Broker Categorization',
              value: ''
          });
        }
        this.$store.dispatch('setBrokerCategorization',broker_categorization);
      })
      .catch(err => console.log(err.response))

      this.$axios.get('campaigns/settings')
      .then(res => {
        if(res.data.campaign_statuses){
          res.data.campaign_statuses.forEach((item,index) => {
            campaign_status.push({value: item, text: item})
          });
        }
        campaign_status.unshift({value: null, text: 'Select Status'})

        this.$store.dispatch('setCampaignStatus', campaign_status);
      })
      .catch(err => console.log(err.response))

      this.$axios.get('premium_enquiries/settings')
      .then(res => {
        if(res.data.projects){
          res.data.projects.forEach((item,index) => {
            premium_enq_projects.push({value: item.id, text: item.name})
          });
        }
        premium_enq_projects.unshift({value: null, text: 'Select projects'})

        this.$store.dispatch('setPremiumEnquiryProjects', premium_enq_projects);

        if(res.data.statuses){
          res.data.statuses.forEach((item,index) => {
            premium_enq_statuses.push({value: item.id, text: item.name})
          });
        }
        premium_enq_statuses.unshift({value: null, text: 'Select Status'})

        this.$store.dispatch('setPremiumEnquiryStatus', premium_enq_statuses);

        if(res.data.brokers_uuids){
          res.data.brokers_uuids.forEach((item,index) => {
            brokers_uuids.push({value: item.id, text: item.uuid})
          });
        }
        brokers_uuids.unshift({value: null, text: 'Select broker uuid'})

        this.$store.dispatch('setBrokerUUId', brokers_uuids);
      })
      .catch(err => console.log(err.response))
  }
}
</script>